import { createSlice, type PayloadAction } from '@ufc/core'

import type { FleetMapResponse } from '../domain/types/api.types'

export interface FleetGpsState {
  result: FleetMapResponse | null
  loading: boolean
  error: string | null
}

const initialState: FleetGpsState = { result: null, loading: false, error: null }

const slice = createSlice({
  name: 'fleetGps',
  initialState,
  reducers: {
    load: (state) => { state.loading = true; state.error = null },
    loadSuccess: (state, action: PayloadAction<FleetMapResponse>) => {
      state.result = action.payload; state.loading = false
    },
    loadFailure: (state, action: PayloadAction<string>) => {
      state.error = action.payload; state.loading = false
    },
  },
})

export const fleetGpsActions = slice.actions
export const fleetGpsReducer = slice.reducer
